import React, { Component } from 'react';
import EirNotification from '../eir-notification/EirNotification';

class DeviceNotification extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    if(this.props.device.availability){
      if(this.props.device.availability.availableDate) {
        return <EirNotification title='Pre-order now' />
      }
    }
     if (this.props.selectedVariant.stockStatus) {
      return <EirNotification className='bg-danger' title={this.props.selectedVariant.stockStatus} />
    } if (this.props.device.flash) {
      return <EirNotification {...this.props.device.flash} />
    } else
    return null;
  }
}

export default DeviceNotification;
